import ApiResponse from '@stores/ApiResponse';
import { AccountabilityPartnerStore } from '@app/api/AccountabilityPartnerStore';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';

export interface AccountabilityPartner {
  id: number;
  cohortUserId: number;
  partnerCohortUserId: number;
  cohortId: number;
  confidence: number;
  matchMade: Date;
}

export class CohortAccountabilityPartnersViewCreator {
  constructor(private readonly accountabilityPartnerStore = new AccountabilityPartnerStore()) {}

  async createView(groupId: number): Promise<AccountabilityPartner[]> {
    return await ApiResponse.handleApiResponse<AccountabilityPartner[]>(() =>
      this.accountabilityPartnerStore.readByCohortId(groupId)
    );
  }
}

// Hook to fetch active participants (legacy)
export const useCohortAccountabilityPartnersViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [CohortAccountabilityPartnersViewCreator.name, groupId],
    queryFn: () => new CohortAccountabilityPartnersViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
  });
